import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Space,
  Input,
  Table,
  Tag,
  Tooltip,
  Empty,
  Drawer,
  Typography,
  Form,
  Modal,
  Grid,
  DatePicker,
} from "antd";
import { EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  GetClientsListApi,
  GetClientsByPartnerClientId,
  GetPartnerClientsListApi,
} from "../ClientsApi";
import {
  resetClientDetailsById,
  resetPartnerClientDetailsById,
} from "../ClientsSlice";
import { FormattedMessage, useIntl } from "react-intl";
import logoicon from "../../../logoicon.png";
import AddClient from "../Clients/AddClient";
import AddPartnerClient from "../PartnerClients/AddPartnerClient";

function ClientsList(props) {
  const { Search } = Input;
  const { Column } = Table;
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { partnerId } = useParams();
  const onSearch = (value, _e, info) => console.log(info?.source, value);
  const ClientsList = useSelector((state) => state.clients.clientsList);
  const PartnerClientsList = useSelector(
    (state) => state.clients.partneclientsList
  );
  const totalPages = useSelector((state) => state.clients.totalPages);
  const companies = useSelector((state) => state.lookup.companyNames);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [clientId, setClientId] = useState(null);
  const [open, setOpen] = useState(false);
  const companyId = localStorage.getItem("CompanyId");
  const [isStatementModalOpen, setIsStatementModalOpen] = useState(false);
  const { useBreakpoint } = Grid;
  const [form] = Form.useForm();
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const showStatementModal = () => {
    setIsStatementModalOpen(true);
  };

  const handleStatementOk = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("Customer Statement Criteria:", values);
        setIsStatementModalOpen(false);
        form.resetFields();
      })
      .catch((info) => {
        console.log("Validation Failed:", info);
      });
  };

  const handleStatementCancel = () => {
    setIsStatementModalOpen(false);
    form.resetFields();
  };
  const showDrawer = () => {
    setClientId(null);
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
    setClientId(null);
  };
  const pagination = {
    pageNo: currentPage,
    pageSize: 10,
    searchQuery: searchTerm,
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };
  const handleEditClick = (id) => {
    setClientId(id);
    setOpen(true);
  };
  useEffect(() => {
    if (props.screen == "clients") {
      if (props?.id) {
        dispatch(GetClientsByPartnerClientId(props?.id, pagination));
      } else {
        dispatch(GetClientsListApi(pagination));
      }
    } else {
      dispatch(GetPartnerClientsListApi(pagination));
    }
  }, [dispatch, props.id, searchTerm, currentPage]);
  // useEffect(() => {
  //   dispatch(GetPartnerClientsListApi(pagination));
  // }, [dispatch, searchTerm, currentPage]);

  useEffect(() => {
    dispatch(resetClientDetailsById());
    if (!partnerId) {
      dispatch(resetPartnerClientDetailsById());
    }
  }, [props.screen]);

  return (
    <>
      <Row justify="space-between" align="bottom" gutter={[16, 8]}>
        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <Search
            placeholder={intl.formatMessage({
              id: "Clients.placeholder.SearchByClientNamePhoneEmailCompanyName",
            })}
            onSearch={handleSearch}
            allowClear
          />
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8} className="text-right">
          <Space>
            <Button
              color="primary"
              variant="outlined"
              onClick={showStatementModal}
            >
              Statement run
            </Button>
            <Button type="primary" onClick={showDrawer}>
              <PlusCircleOutlined />
              {props.screen == "clients" ? (
                <FormattedMessage id="Clients.AddClient" />
              ) : (
                <FormattedMessage id="PartnerCLient.AddPartner" />
              )}
            </Button>
          </Space>
        </Col>
      </Row>
      <Table
        dataSource={
          props.screen == "clients" ? ClientsList : PartnerClientsList
        }
        className="mt-10"
        bordered
        pagination={{
          current: currentPage,
          total: totalPages * 10,
          showSizeChanger: false,
          onChange: handlePageChange,
        }}
        scroll={{ x: 1000 }}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={intl.formatMessage({
                id: "NoData",
              })}
            />
          ),
        }}
      >
        {/* <Column
            title={<FormattedMessage id="Vendors.Name" />}
            key="companyName"
            render={(_, record) => (
              <Link
                style={{ textTransform: "capitalize" }}
                to={
                  props.screen == "clients"
                    ? `/client_details/${record?.id}`
                    : `/partner_client_details/${record?.id}`
                }
              >{`${
                record?.isResidential == true
                  ? record?.name
                  : record?.companyName
              }`}</Link>
            )}
          /> */}
        <Column
          title={<FormattedMessage id="Vendors.Name" />}
          key="companyName"
          // width={220}  Needed so the cell knows its boundary
          ellipsis={{ showTitle: false }} // showTitle:false = no default tooltip
          render={(_, record) => {
            const displayText = record?.isResidential
              ? record?.name
              : record?.companyName;

            const link =
              props.screen === "clients" && !props?.id
                ? `/${companyId}/${record.id}/client_details`
                : props.screen === "clients" && props?.id
                ? `/${companyId}/${partnerId}/partner_client_details/${record.id}/client_details`
                : `/${companyId}/${record.id}/partner_client_details`;

            return (
              // Typography.Text keeps the inline‑block so the CSS ellipsis works.
              <Typography.Text ellipsis style={{ width: "100%" }}>
                <Link to={link} style={{ textTransform: "capitalize" }}>
                  {displayText}
                </Link>
              </Typography.Text>
            );
          }}
        />

        {/* <Column
            title={<FormattedMessage id="AddClient.MappedCompany" />}
            key="assignedcompany"
            render={(_, record) => (
              <div>
                {record.clientCompanyMapIds?.length > 0 ? (
                  record.clientCompanyMapIds.map((id, index) => {
                    const company = companies?.find((c) => c.id === id);
                    return company ? (
                      <div key={index}>
                        <img
                          src={logoicon}
                          alt="Company Logo"
                          style={{
                            width: "16px",
                            marginRight: 3,
                            position: "relative",
                            top: "2px",
                          }}
                        />
                        {company.companyName}
                      </div>
                    ) : null;
                  })
                ) : (
                  <span>-</span>
                )}
              </div>
            )}
          /> */}
        <Column
          title={<FormattedMessage id="Clients.Phonenumber" />}
          key="phone"
          width={180}
          render={(_, record) => {
            const phone = record?.phone || "";
            const digits = phone.replace(/\D/g, "").slice(0, 10); // just in case

            const formatted =
              digits.length === 10
                ? `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(
                    6
                  )}`
                : phone; // fallback to raw if not 10 digits

            return <Space size="small">{formatted}</Space>;
          }}
        />

        <Column
          ellipsis={{ showTitle: false }}
          title={<FormattedMessage id="Clients.EMail" />}
          key="email"
          render={(_, record) => (
            <Typography.Text
              ellipsis
              style={{ width: "100%" }}
              title={`${record?.email}`}
            >
              {`${record?.email}`}
            </Typography.Text>
          )}
        />
        {props.screen == "clients" ? (
          <Column
            title={<FormattedMessage id="AddClient.ClientType" />}
            key="name"
            width={150}
            render={(_, record) => (
              <Space size="small">
                {record?.isResidential ? "Residential" : " Commercial"}
              </Space>
            )}
          />
        ) : (
          <Column
            title={<FormattedMessage id="PartnerCLient.Creditlimit" />}
            key="name"
            render={(_, record) => (
              <Space size="small">
                ${`${record?.creditLimit ? record?.creditLimit : "N/A"}`}
              </Space>
            )}
          />
        )}
        <Column
          title="Balance Due"
          key="balancedue"
          width={100}
          render={(_, record) => <Space size="small">2000</Space>}
        />

        <Column
          title={<FormattedMessage id="Clients.Status" />}
          dataIndex="isActive"
          width={100}
          key="status"
          render={(isActive) => (
            <Tag color={isActive ? "#6FCF97" : "#EB5757"}>
              {isActive ? (
                <>{<FormattedMessage id="Common.Active" />}</>
              ) : (
                <>{<FormattedMessage id="Common.InActive" />}</>
              )}
            </Tag>
          )}
        />

        <Column
          title={<FormattedMessage id="Clients.Action" />}
          key="action"
          width={100}
          render={(_, record) => (
            <Space size="middle">
              <Tooltip
                title={
                  props.screen == "clients" ? "Edit client" : "Edit partner"
                }
              >
                <Button
                  size="small"
                  onClick={() => handleEditClick(record?.id)}
                >
                  <EditOutlined />
                </Button>
              </Tooltip>
            </Space>
          )}
        />
      </Table>

      {props.screen == "clients" ? (
        <Drawer
          title={
            !clientId ? (
              <FormattedMessage id="AddClient.AddClient" />
            ) : (
              <FormattedMessage id="AddClient.EditClient" />
            )
          }
          onClose={onClose}
          open={open}
          width={600}
        >
          <AddClient
            onClose={onClose}
            pagination={pagination}
            clientId={clientId}
            partnerClientId={props?.id}
            isValidationRequired={true}
          />
        </Drawer>
      ) : (
        <Drawer
          title={
            !clientId ? (
              <FormattedMessage id="PartnerCLient.AddPartner" />
            ) : (
              <FormattedMessage id="PartnerCLient.EditPartner" />
            )
          }
          onClose={onClose}
          open={open}
          width={600}
        >
          <AddPartnerClient
            onClose={onClose}
            pagination={pagination}
            clientId={clientId}
            isValidationRequired={true}
          />
        </Drawer>
      )}
      <Modal
        title="Customer statement run"
        open={isStatementModalOpen}
        onOk={handleStatementOk}
        onCancel={handleStatementCancel}
        okText="Next"
        cancelButtonProps={{ style: { display: "none" } }} // Hide cancel if not needed
      >
        <p>
          Generate customer statements for all your customers based on their
          settings and the following criteria:
        </p>
        <Form
          form={form}
          className="mt-20"
          layout={isMobile ? "vertical" : "horizontal"} // ✅ auto switch
          labelCol={isMobile ? undefined : { flex: "0 0 50%" }}
          wrapperCol={isMobile ? undefined : { flex: "0 0 50%" }}
          labelAlign="left"
          colon={false}
          initialValues={{
            outstandingAmount: 0.0,
            statementDate: dayjs(),
          }}
          style={{ width: "100%" }}
        >
          <Form.Item
            name="outstandingAmount"
            label="Outstanding amount over"
            rules={[{ required: true, message: "Please enter an amount" }]}
          >
            <Input type="number" step="0.01" />
          </Form.Item>

          <Form.Item
            name="statementDate"
            label="Produce statement as of"
            rules={[{ required: true, message: "Please select a date" }]}
          >
            <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default ClientsList;
